import { useEffect, useState } from "react";
import { CalculatorPage } from "@/components/calculator";
import { ErrorBoundary, Layout } from "@/components/common";
import { IntroductionPage } from "@/components/introduction";
import { i18nManager } from "@/lib/i18n";

type AppPage = "introduction" | "calculator";

/**
 * Application principale du calculateur CO2 Transmoove
 * Gère la navigation entre les pages
 */
function App() {
  const [currentPage, setCurrentPage] = useState<AppPage>("introduction");
  const [isLoading, setIsLoading] = useState(true);

  // Initialisation de l'application au montage du composant
  useEffect(() => {
    const initializeApp = async () => {
      try {
        // Charger les traductions et initialiser la langue
        await i18nManager.ensureLoaded();
        setIsLoading(false);
      } catch (error) {
        console.error(
          "Erreur lors de l'initialisation de l'application:",
          error,
        );
        setIsLoading(false);
      }
    };

    initializeApp();
  }, []);

  const handleNavigateToCalculator = () => {
    setCurrentPage("calculator");
  };

  const handleNavigateToIntroduction = () => {
    setCurrentPage("introduction");
  };

  // Écran de chargement
  if (isLoading) {
    return (
      <div className="tm-page flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
          <p className="text-transmoove-text">
            Chargement du calculateur CO₂ Transmoove...
          </p>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <Layout>
        {currentPage === "introduction" && (
          <IntroductionPage
            onNavigateToCalculator={handleNavigateToCalculator}
          />
        )}

        {currentPage === "calculator" && (
          <CalculatorPage
            onNavigateToIntroduction={handleNavigateToIntroduction}
          />
        )}
      </Layout>
    </ErrorBoundary>
  );
}

export default App;
